// @ts-ignore
import theme from './vendor/index'

export default theme
